module.exports = "https://static.energy5.com/_next/static/images/contactHeaderBg-e03c56019209e7b5653188caaf9076f7.webp";